// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const silo = defineModel({
  id: "silo",
  batchId: "future",
  name: "Silo",
  tags: ["building","silo","low-poly","age-of-mcp","future"],
  summary: "A tall silo storing bulk grain, ore, sand or cement between chains.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.4, 0.14, 1.4), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.4, 0.14, 1.4), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.5, 0.54, 0.18, 12), color: "#8a857a", position: [0, 0.23, 0] },
      { geometry: new THREE.CylinderGeometry(0.44, 0.46, 0.55, 12), color: "#cdbf9a", position: [0, 0.595, 0] },
      { geometry: new THREE.CylinderGeometry(0.47, 0.47, 0.05, 12), color: "#9b8e68", position: [0, 0.485, 0] },
      { geometry: new THREE.CylinderGeometry(0.47, 0.47, 0.05, 12), color: "#9b8e68", position: [0, 0.705, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.6, 0.475, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.6, 0.475, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.6, 0.475, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.6, 0.475, 0.6] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.4, 0.14, 1.4), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.5, 0.54, 0.18, 12), color: "#8a857a", position: [0, 0.23, 0] },
      { geometry: new THREE.CylinderGeometry(0.44, 0.46, 1.1, 12), color: "#cdbf9a", position: [0, 0.87, 0] },
      { geometry: new THREE.CylinderGeometry(0.47, 0.47, 0.05, 12), color: "#9b8e68", position: [0, 0.65, 0] },
      { geometry: new THREE.CylinderGeometry(0.47, 0.47, 0.05, 12), color: "#9b8e68", position: [0, 1.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [-0.6, 0.8, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [0.6, 0.8, -0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [-0.6, 0.8, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.6, 4), color: "#6b4a26", position: [0.6, 0.8, 0.6] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.4, 0.14, 1.4), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.5, 0.54, 0.18, 12), color: "#8a857a", position: [0, 0.23, 0] },
      { geometry: new THREE.CylinderGeometry(0.44, 0.46, 1.45, 12), color: "#cdbf9a", position: [0, 1.045, 0] },
      { geometry: new THREE.CylinderGeometry(0.47, 0.47, 0.05, 12), color: "#9b8e68", position: [0, 0.755, 0] },
      { geometry: new THREE.CylinderGeometry(0.47, 0.47, 0.05, 12), color: "#9b8e68", position: [0, 1.335, 0] },
      { geometry: new THREE.ConeGeometry(0.5, 0.4, 12), color: "#6f4a2c", position: [0, 1.97, 0] },
      { geometry: new THREE.BoxGeometry(0.025, 1.63, 0.025), color: "#5b4326", position: [-0.07, 0.955, 0.47] },
      { geometry: new THREE.BoxGeometry(0.025, 1.63, 0.025), color: "#5b4326", position: [0.07, 0.955, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 0.303, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 0.466, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 0.629, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 0.792, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 0.955, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 1.118, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 1.281, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 1.444, 0.47] },
      { geometry: new THREE.BoxGeometry(0.18, 0.02, 0.02), color: "#5b4326", position: [0, 1.607, 0.47] },
    ] },
  ],
  animations: [],
});
